import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

export default function History() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/attempts").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <div className="mb-6">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[hsl(var(--brand-orange))]">History</div>
        <h1 className="mt-1 font-display text-3xl font-bold">Your quiz attempts</h1>
      </div>
      <Card className="border-border/70">
        <CardContent className="p-0">
          {loading ? (
            <div className="space-y-2 p-6">
              {Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-10" />)}
            </div>
          ) : items.length === 0 ? (
            <div className="p-10 text-center text-sm text-muted-foreground">
              No attempts yet. <Link to="/quiz/new" className="font-semibold text-[hsl(var(--brand-navy))] underline">Start your first quiz.</Link>
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Date</TableHead>
                  <TableHead>Mode</TableHead>
                  <TableHead>Score</TableHead>
                  <TableHead>%</TableHead>
                  <TableHead>Time</TableHead>
                  <TableHead></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {items.map((a) => (
                  <TableRow key={a.id} data-testid={`history-row-${a.id}`}>
                    <TableCell>{new Date(a.submitted_at).toLocaleString()}</TableCell>
                    <TableCell className="capitalize">{a.mode}</TableCell>
                    <TableCell>{a.score}/{a.total}</TableCell>
                    <TableCell className="font-mono">{a.percentage}%</TableCell>
                    <TableCell className="font-mono text-xs">{Math.floor((a.time_taken_seconds || 0) / 60)}m {(a.time_taken_seconds || 0) % 60}s</TableCell>
                    <TableCell className="text-right">
                      <Button asChild size="sm" variant="outline" data-testid={`history-view-${a.id}`}>
                        <Link to={`/quiz/${a.id}/result`}>Review</Link>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
